export const SHORT_DESCRIPTION_MAX_LENGTH = 200;
